import React, {Component} from "react"
import {connect} from "react-redux";
import withStyles from "@mui/styles/withStyles";
import CardContent from "@mui/material/CardContent";
import TextField from "@mui/material/TextField";
import CardActions from "@mui/material/CardActions";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import {clear_auth_messages, clear_forgot_password_status, forgot_password} from "../../actions/auth";
import SnackbarMessage from "../Custom/SnackbarMessage";
import Validator from "../../utilities/validator";
import CircularProgress from "@mui/material/CircularProgress";
import ReCAPTCHA from "react-google-recaptcha";
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import {switchMode} from "../../actions/theming";

const styles = {
    password: {
        "margin-top": 10
    },
    centered: {
        "text-align": "center",
        "paddingTop": 24,
        "paddingBottom": 24
    },
    loginWrapper: {
        textAlign: "center",
        paddingTop: "25vh",
        minHeight: "calc(100vh - 83px)",
        marginBottom: "60px"
    },
    logo: {
        paddingTop: 15,
        paddingBottom: 15,
        fontWeight: "bold",
        color: "white"
    },
    loginButtons: {
        flexDirection: "row-reverse"
    },
    loginHint: {
        flex: "auto"
    },
    buttonProgress: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -10,
        marginLeft: -10,
    },
    buttonProgressContainer: {
        position: 'relative'
    },
    backToLogin: {
        marginBottom: 10
    },
    darkModeSwitch: {
        position: "fixed",
        top: "10px",
        right: "10px"
    }
};


class ForgotPassword extends Component {
    constructor(props) {
        super(props);

        this.recaptchaRef = React.createRef();
        this.state = {
            email: "",
            emailTouched: false,
        };
    }

    componentDidMount() {
        this.props.clear_auth_messages();
    }

    onSubmit = e => {
        e.preventDefault();
        this.recaptchaRef.current.execute().then(res => {
            const recaptchaToken = res;
            const {email} = this.state;

            if (Validator.isEmailValid(email)) {
                this.props.forgot_password(this.state.email, recaptchaToken);
            } else {
                this.setState({
                    ...this.state,
                    emailTouched: true
                });
            }
        });
    };

    onChange = e => this.setState({
        ...this.state,
        [e.target.name]: e.target.value,
        [e.target.name + 'Touched']: true
    });

    render() {
        const {classes} = this.props;
        const {email, emailTouched} = this.state;

        let errors = false;
        if (this.props.auth.forgot_password !== null) {
            if (this.props.auth.forgot_password.status === "success") {
                this.props.history.push("/");
            } else if (this.props.auth.forgot_password.status === "error") {
                if (this.props.auth.forgot_password.errors) {
                    let errors_array = [];
                    Object.keys(this.props.auth.forgot_password.errors).map((field) => {
                        errors_array = [...errors_array, ...this.props.auth.forgot_password.errors[field]];
                    });
                    errors = (
                        <>
                            <SnackbarMessage onClose={this.props.clear_forgot_password_status} type="error"
                                             message={errors_array.join(", ")} autoHideDuration={null}
                                             anchorOrigin={false}
                                             style={{marginBottom: 15}}/>
                        </>
                    )
                } else {
                    errors = (
                        <>
                            <SnackbarMessage onClose={this.props.clear_forgot_password_status} type="error"
                                             message={this.props.auth.forgot_password.message} autoHideDuration={null}
                                             anchorOrigin={false}
                                             style={{marginBottom: 15}}/>
                        </>
                    )
                }
            }
        }
        return (
            <form onSubmit={this.onSubmit} id="reset-password">
                <CardContent>
                    <Button color="inherit" disabled={this.props.auth.is_waiting}
                            className={classes.backToLogin}
                            onClick={(e) => {
                                e.preventDefault();
                                this.props.history.push("/auth/login")
                            }}
                            size="small"
                            startIcon={<ChevronLeftIcon/>}
                    >Back to login</Button>
                    {errors}
                    <TextField fullWidth label="E-mail" type="email"
                               name="email"
                               variant="standard"
                               value={email}
                               onChange={this.onChange}
                               error={emailTouched && !Validator.isEmailValid(email)}
                               helperText={emailTouched && !Validator.isEmailValid(email) ? "Please enter a valid e-mail" : ""}
                    />
                    <ReCAPTCHA
                        ref={this.recaptchaRef}
                        size="invisible"
                        sitekey="6LcpS7kaAAAAACvn4UE6Mui2XRYfVyOSZROzvF9I"
                        // onChange={onChange}
                    />
                </CardContent>
                <CardActions className={classes.loginButtons}>
                    <div className={classes.buttonProgressContainer}>
                        <Button type="submit"
                                variant="contained"
                                color="primary"
                                disabled={email.trim().length === 0 || this.props.auth.is_waiting || (emailTouched && !Validator.isEmailValid(email))}
                        >
                            Send
                        </Button>
                        {this.props.auth.is_waiting &&
                        <CircularProgress size={20} className={classes.buttonProgress}/>}
                    </div>

                    <Typography className={classes.loginHint} variant="caption">
                        Enter your email address to reset your password.
                    </Typography>
                </CardActions>

            </form>
        )
    }
}

const mapStateToProps = state => ({
    auth: state.auth,
    theming: state.theming
});

export default withStyles(styles)(connect(
    mapStateToProps,
    {forgot_password, clear_forgot_password_status, switchMode, clear_auth_messages}
)(ForgotPassword));
